<div gdColumns="repeat(auto-fill, minmax(250px, 1fr))" gdGap="10px" [formGroup]="form">
	<mat-form-field *ngIf="this.form.value.id !== 0">
		<input matInput placeholder="Number" formControlName="number" readonly
			matTooltip="This field is not editable" />
	</mat-form-field>
	<rpshared-customer-link-with-add required multiline formControlName="customer"
		(optionSelected)="customerSelected($event)"></rpshared-customer-link-with-add>
	<rpshared-railroad-link required formControlName="railroad"
		(optionSelected)="railroadSelected($event)"></rpshared-railroad-link>
	<rpshared-division-link formControlName="division" [divisions]="divisions$ | async"
		(optionSelected)="divisionSelected($event)"></rpshared-division-link>
	<rpshared-select-list required formControlName="regularTimeBasis" placeholder="Regular Time Basis"
		[items]="regularTimeBasisTypes"></rpshared-select-list>
	<rpshared-select-list required formControlName="overTimeBasis" placeholder="Overtime Basis"
		[items]="overtimeBasisTypes"></rpshared-select-list>
	<rpshared-field-team-link required formControlName="team"></rpshared-field-team-link>
	<rpshared-date-picker required formControlName="start" placeholder="Job start date"
		clearable></rpshared-date-picker>
	<rpshared-date-picker required formControlName="end" placeholder="Job end date" clearable></rpshared-date-picker>
	<rpshared-select-list required formControlName="party" placeholder="Party"
		[items]="jobPartyTypes"></rpshared-select-list>
	<rpshared-select-list required formControlName="jobType" placeholder="Type of Work" [items]="typesOfWork"
		[displayFunc]="displayJobType"></rpshared-select-list>
	<rpshared-select-list required formControlName="endMarket" placeholder="End Market" [items]="endMarket"
		[displayFunc]="displayEndMarket"></rpshared-select-list>
	<mat-form-field>
		<input autocomplete="off" matInput spellcheck="false" autocomplete="off" maxlength="3"
			placeholder="Days Requested (under scheduling fee)" formControlName="daysRequested" />
		<mat-error *ngIf="form.get('daysRequested').hasError('max')">
			Maximum value of 15.
		</mat-error>
		<mat-error *ngIf="form.get('daysRequested').hasError('min')">
			Must be a positive value.
		</mat-error>
		<mat-error *ngIf="form.get('daysRequested').hasError('required')">
			Required
		</mat-error>
	</mat-form-field>
	<mat-form-field>
		<input autocomplete="off" matInput spellcheck="false" autocomplete="off" maxlength="30"
			placeholder="Permit Number" formControlName="permitNumber" />
	</mat-form-field>
	<mat-form-field>
		<mat-select formControlName="quoteStatus" disableOptionCentering="true" placeholder="Quote Status">
			<mat-option *ngFor="let status of quoteStatuses" [value]="status">
				{{ displayQuoteStatus[status] }}
			</mat-option>
		</mat-select>
	</mat-form-field>
	<mat-form-field>
		<mat-select (openedChange)="offeredServicesToggle()" (selectionChange)="offeredServiceChange($event)"
			[compareWith]="idComparer" formControlName="offeredServices" disableOptionCentering="true"
			placeholder="Offered Services" multiple>
			<mat-option *ngFor="let service of offeredServices$ | async" [value]="service">
				{{ displayName(service) }}
				{{ service.isActive ? '' : '(Inactive)' }}
			</mat-option>
		</mat-select>
	</mat-form-field>
	<mat-slide-toggle formControlName="isSafetyTrainingComplete" labelPosition="before" class="custom-slider">Safety
		Training Complete
	</mat-slide-toggle>
	<mat-slide-toggle formControlName="isNonBillable" labelPosition="before" class="custom-slider">Non-Billable Job
	</mat-slide-toggle>
	<mat-form-field>
		<input autocomplete="off" matInput maxlength="256" placeholder="Track Supervisor / Roadmaster"
			formControlName="trackSupervisor" />
	</mat-form-field>
	<mat-form-field *ngIf="showOrderNumber$ | async">
		<input autocomplete="off" matInput maxlength="256" placeholder="Order #" formControlName="orderNumber"
			[required]="showOrderNumber$ | async" />
		<mat-error>Required</mat-error>
	</mat-form-field>
	<mat-form-field *ngIf="showTrackID$ | async">
		<mat-select formControlName="trackID" disableOptionCentering="true" placeholder="Track ID"
			[required]="showTrackID$ | async">
			<mat-option *ngFor="let jobTrackID of jobTrackIDs" [value]="jobTrackID">
				{{ displayJobTrackID[jobTrackID] }}
			</mat-option>
		</mat-select>
		<mat-error>Required</mat-error>
	</mat-form-field>
	<mat-form-field gdColumn="1 / -1">
		<input matInput autocomplete="off" placeholder="Description of Schedule"
			formControlName="descriptionOfSchedule" />
		<mat-hint>e.g. Mon - Fri, 8am - 6pm</mat-hint>
	</mat-form-field>
	<mat-form-field gdColumn="1 / -1">
		<input matInput autocomplete="off" placeholder="Equipment Description" formControlName="equipmentDescription" />
	</mat-form-field>
	<mat-form-field gdColumn="1 / -1">
		<textarea required matInput maxlength="100" cdkTextareaAutosize cdkAutosizeMinRows="2" placeholder="Description"
			formControlName="description">
		</textarea>
		<mat-error>Required</mat-error>
	</mat-form-field>
	<mat-form-field gdColumn="1 / -1">
		<textarea matInput cdkTextareaAutosize cdkAutosizeMinRows="2" placeholder="Additional Job Details"
			formControlName="notes">
		</textarea>
	</mat-form-field>

	<rpshared-multi-chip-input gdColumn="1 / -1" placeholder="Send Dwr Approval Notifications To"
		formControlName="dwrNotificationRecipients"></rpshared-multi-chip-input>
</div>